import { connect } from 'react-redux';


const mapStateToProps = (state: { globalErrors: { data: unknown } }) => {
  return {
    globalErrors: state.globalErrors.data,
  };
};

export default connect(mapStateToProps);